
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import SignInForm from './SignInForm';
import SignUpForm from './SignUpForm';

interface AuthTabsProps {
  onSignInSuccess: () => void;
  onSignUpSuccess: () => void;
  onCancel: () => void;
}

const AuthTabs = ({ onSignInSuccess, onSignUpSuccess, onCancel }: AuthTabsProps) => {
  return (
    <Tabs defaultValue="signin" className="w-full">
      <TabsList className="grid w-full grid-cols-2 mb-6">
        <TabsTrigger value="signin">Sign In</TabsTrigger>
        <TabsTrigger value="signup">Sign Up</TabsTrigger>
      </TabsList>

      <TabsContent value="signin">
        <SignInForm onSuccess={onSignInSuccess} onCancel={onCancel} />
      </TabsContent>

      <TabsContent value="signup">
        <SignUpForm onSuccess={onSignUpSuccess} onCancel={onCancel} />
      </TabsContent>
    </Tabs>
  );
};

export default AuthTabs;
